export default __webpack_public_path__ + "static/media/ST.270e0261.ico";